import api from './axiosInstance';

export const customerApi = {
  list: (params = {}) => api.get('/customers', {params}),
  search: query => api.get('/customers/search', {params: {q: query}}),
  getById: id => api.get(`/customers/${id}`),
  create: data => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: id => api.delete(`/customers/${id}`),
  getOrders: (id, params = {}) =>
    api.get(`/customers/${id}/orders`, {params}),
  getMeasurements: id => api.get(`/customers/${id}/measurements`),
  getStats: id => api.get(`/customers/${id}/stats`),
  uploadImages: (id, formData) =>
    api.post(`/customers/${id}/images`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    }),
  getDueOrders: id => api.get(`/customers/${id}/due-orders`),
  getLedger: id => api.get(`/customers/${id}/ledger`),
  createBulkPayment: (id, data) => api.post(`/customers/${id}/bulk-payment`, data),
  getReferralSources: () => api.get('/referral-sources'),
  createReferralSource: data => api.post('/referral-sources', data),
};
